// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"ManageAttributes_deleteButton__CthH_","attributesContainer":"ManageAttributes_attributesContainer__19hnO"};